import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconClipboard"><Path d="M15.25 4.75H16.25C17.9069 4.75 19.25 6.09315 19.25 7.75V18.25C19.25 19.9069 17.9069 21.25 16.25 21.25H7.75C6.09315 21.25 4.75 19.9069 4.75 18.25V7.75C4.75 6.09315 6.09315 4.75 7.75 4.75H8.75M9.75 7.25H14.25C14.8023 7.25 15.25 6.80228 15.25 6.25V5.75C15.25 4.09315 13.9069 2.75 12.25 2.75H11.75C10.0931 2.75 8.75 4.09315 8.75 5.75V6.25C8.75 6.80228 9.19772 7.25 9.75 7.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconClipboard;
